import BossModel from "@/models/BossModel";
import Detail from "@/models/Agent/Product/Detail/Detail";
import Status from "@/models/Agent/Product/Status/Status";
import AgentCode from "@/models/Agent/Code/Code";
import AgentPreset from "@/models/Proposal/Product/AgentPreset/AgentPreset";
import Proposal from "@/models/Proposal/Proposal";
import {sortBy} from "lodash";
import Price from "@/models/Agent/Product/Price/Price";

export default class Product extends BossModel {

    static apiUrl = 'agent/product';

    static entity = 'agentProducts';

    static fields() {
        return {
            id: this.number(null).nullable(),
            hash: this.attr(null),
            dossier_id: this.number(null).nullable(),
            agent_reservation_id: this.number(null).nullable(),
            agent_code_id: this.number(null).nullable(),
            reference: this.attr(null),
            name: this.attr(null),
            start_date: this.attr(null),
            end_date: this.attr(null),
            notes: this.attr(null),
            travalco_booking_eid: this.attr(null),
            is_pending: this.boolean(0),
            is_check_needed: this.boolean(0),
            last_checked_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            details: this.hasMany(Detail, 'agent_product_id'),
            status: this.hasOne(Status, 'agent_product_id'),
            statuses: this.hasMany(Status, 'agent_product_id'),
            agentCode: this.belongsTo(AgentCode, 'agent_code_id'),
            agentPresets: this.hasMany(AgentPreset, 'hash', 'hash'),
            price: this.hasOne(Price, 'agent_product_id'),
            prices: this.hasMany(Price, 'agent_product_id'),
        }
    }

    cancel() {
        return this.constructor.api().action(this.id + '/cancel').update();
    }

    downloadStatus() {
        return this.constructor.api().action(this.id + '/download-status').update();
    }

    get lastStatus() {
        const statuses = this.getRelated('statuses');

        if (statuses.length === 0) {
            throw new Error('AgentProduct.lastStatus is not found of product ' + this.id);
        }

        return sortBy(statuses, 'id').pop();
    }

    get lastPrice() {
        const prices = this.getRelated('prices');

        if (prices.length === 0) {
            return null;
        }

        return sortBy(prices, 'id').pop();
    }

    fetchCancellationPolicies() {
        return this.constructor.api().action(this.id + '/cancellation-policies').get();
    }

    static getUnusedProduct(proposalId) {
        const proposal = Proposal.query().find(proposalId);
        return this.query()
            .where('dossier_id', proposal.dossier_id)
            .whereHasNot('agentPresets', query => {
                query.whereHas('product', query => {
                    query.whereHas('group', query => {
                        query.where('proposal_id', proposal.id);
                    });
                })
            }).where(product => {
                return product.lastStatus.IsRequested() || product.lastStatus.IsConfirmed()
            }).get();
    }
}
